import React from 'react'
import { LayoutFlows } from '../../screens/flows/layout/LayoutFlows'

export const FlowsScreen = () => {
  return (
    <LayoutFlows/>
  )
}
